import React from "react";
import { useTranslation } from "react-i18next";

const Footer = () => {
    const { t } = useTranslation();
    return (
        <footer className="siteFooter">
            <p>&copy; {new Date().getFullYear()} Jani Luostarinen. {t("footer.builtWith")}</p>
        </footer>
    );
}
export default Footer;
